module.exports = __webpack_public_path__ + "assets/images/basic-circle@3x-9775fd203c3a4bbb8f98c03a6630302b.png";